export const CONSTANTS = {
  FREE_MATERIAL_ENROLLMENT_NUMBER: "enrollment_whatsapp_number",
  FREE_MATERIAL_ENROLLMENT_MESSAGE: "السلام عليكم كنت حابب اشترك في كورس",
} as const
